import { useState, useEffect } from 'react';

// Hardcoded current version of Terms of Service
const CURRENT_TERMS_VERSION = '12-06-2025';
const TERMS_STORAGE_KEY = 'termsAcceptance';

export const useTermsAcceptance = (userEmail = null) => {
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  // Check if user needs to re-accept terms
  useEffect(() => {
    const checkTermsAcceptance = () => {
      try {
        if(null === userEmail || undefined === userEmail || userEmail?.trim() === "") return;

        const stored = localStorage.getItem(TERMS_STORAGE_KEY);
        if (!stored) {
          // No previous acceptance - Default to not reaccepting.
          acceptTerms(); // Automatically first accept terms
          setShowTermsModal(false);
          return;
        }

        const acceptanceData = JSON.parse(stored);
        
        // Check if the stored version matches current version
        if (acceptanceData.version !== CURRENT_TERMS_VERSION) {
          // Terms have been updated - show modal
          setShowTermsModal(true);
          return;
        }

        // All checks passed - user has accepted current terms
        setTermsAccepted(true);
      } catch (error) {
        console.error('Error checking terms acceptance:', error);
        // If there's an error parsing, show modal to be safe
        setShowTermsModal(true);
      }
    };

    checkTermsAcceptance();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userEmail]);

  // Accept terms and store in localStorage
  const acceptTerms = () => {
    try {
      const acceptanceData = {
        version: CURRENT_TERMS_VERSION,
        acceptedDate: new Date().toISOString(),
        userEmail: userEmail || null,
      };

      localStorage.setItem(TERMS_STORAGE_KEY, JSON.stringify(acceptanceData));
      setTermsAccepted(true);
      setShowTermsModal(false);
    } catch (error) {
      console.error('Error storing terms acceptance:', error);
    }
  };

  // Decline terms (just close modal for now)
  const declineTerms = () => {
    setShowTermsModal(false);
    // Could add additional logic here like logout or redirect
  };

  // Force show modal (for testing or manual triggers)
  const forceShowTermsModal = () => {
    setShowTermsModal(true);
  };

  // Open Terms of Service in new window
  const openTermsInNewWindow = () => {
    window.open('/Terms.html', '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
  };

  return {
    showTermsModal,
    termsAccepted,
    acceptTerms,
    declineTerms,
    forceShowTermsModal,
    openTermsInNewWindow,
    currentTermsVersion: CURRENT_TERMS_VERSION,
  };
};